import React from "react";

import "./index.css";

export const CustomLoader = ({ size = 20 }) => {
  return (
    <div
      className="spinner"
      style={{
        borderTopColor: "#8483B4",
        height: size,
        width: size,
      }}
    />
  );
};
